import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import Swal from "sweetalert2";

export default function AlertResponses(args) {
  const status = {
    success: {
      text: args.title,
      msg: args.message,
      icon: "success",
      iconColor: "#2BC155",
    },
    warning: {
      text: args.title,
      msg: args.message,
      icon: "warning",
      iconColor: "#FCC419",
    },
    error: {
      text: args.title,
      msg: args.message,
      icon: "error",
      iconColor: "#FF4343",
    },
  };

  const Toast = Swal.mixin({
    toast: true,
    position: args.pageLogin === undefined ? "bottom-end" : "bottom-end",
    timer: 4000,
    timerProgressBar: true,
    showConfirmButton: false,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
    customClass: {
      popup: "swal2-toast-custom",
      title: "swal2-toast-title",
      htmlContainer: "swal2-toast-content",
    },
  });

  useEffect(() => {
    if (!args.visible) return;

    const currentStatus = status[args.type] || status.error;

    Toast.fire({
      icon: currentStatus.icon,
      iconColor: currentStatus.iconColor,
      title: currentStatus.text,
      html: `<p style="margin: 0">${currentStatus.msg}</p>`,
    }).then(() => {
      args.setNotify((prev) => ({ ...prev, visible: false }));
    });
  }, [args.visible]); // Removido alertType das dependências

  return null;
}

export function AlertV2(args) {
  const [alertType, setAlertType] = useState({});

  const status = {
    success: {
      text: args.title,
      msg: args.message,
      variant: "success",
      icon: "check-circle-outline",
    },
    warning: {
      text: args.title,
      msg: args.message,
      variant: "warning",
      icon: "alert-outline",
    },
    error: {
      text: args.title,
      msg: args.message,
      variant: "danger",
      icon: "alert",
    },
  };

  useEffect(() => {
    if (args.type === "success") setAlertType(status.success);
    if (args.type === "error") setAlertType(status.error);
    if (args.type === "warning") setAlertType(status.warning);
    setTimeout(() => {
      args.setNotify({ ...args.visible, visible: false });
    }, 4000);

    document
      .querySelector(".alert-dismissible .close")
      .addEventListener("click", () => {
        args.setNotify({ ...args.visible, visible: false });
      });
  }, [args.visible]);

  return (
    <Alert
      variant={alertType.variant}
      className="alert-dismissible fade show solid"
      dismissible={true}
      show={args.visible}
    >
      <strong>{alertType.text}</strong> {alertType.msg}
    </Alert>
  );
}

const styles = {
  alert: {
    position: "fixed",
    bottom: 0,
    right: 0,
    zIndex: 1000000000000000,
    maxWidth: "400px",
  },
};
